import {
  useGetAdminAlumniQuery,
  useGetAdminEventsQuery,
  useGetAdminHallQuery,
  useGetAdminIupcQuery,
} from "../../features/api/appApi";
import AdminSectionCard, { AdminStatCard } from "./AdminSectionCard";

const AdminOverviewPage = () => {
  const { data: events = [] } = useGetAdminEventsQuery();
  const { data: iupcs = [] } = useGetAdminIupcQuery();
  const { data: alumni = [] } = useGetAdminAlumniQuery();
  const { data: hallOfShame = [] } = useGetAdminHallQuery();

  return (
    <AdminSectionCard title="Overview" subtitle="Quick snapshot of your content modules">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 2xl:grid-cols-4">
        <AdminStatCard title="Events" value={events.length} tone="blue" />
        <AdminStatCard title="IUPC Entries" value={iupcs.length} tone="green" />
        <AdminStatCard title="Alumni" value={alumni.length} tone="amber" />
        <AdminStatCard title="Hall Records" value={hallOfShame.length} tone="slate" />
      </div>
    </AdminSectionCard>
  );
};

export default AdminOverviewPage;
